import styled from 'styled-components';

export const PaginationWrapper = styled.ul`
    display: flex;
    margin: 20px 0;

  &.pagination-active {
    background-color: #da9c15;
  }
  li > a {
    border: 0;
    border-radius: 30px !important;
    transition: all .3s;
    padding: 0px 11px;
    margin: 0 10px;
    min-width: 37px;
    text-align: center;
    height: 37px;
    line-height: 37px;
    cursor: pointer;
    float: left;
    font-size: 14px;
    text-transform: uppercase;
    background: transparent;
    outline: none;
    @media (max-width: 510px){
      margin: 0;
    }
  }
  li > a, li > span {
    color: #da9c15;
  }
  li > a:hover, li > span:hover, li > a:focus, li > span:focus {
    color: #fff;
    background-color: #edbd2f;
  }
  li > a:focus {
      color: #da9c15;
      background-color: #fff;
  }
  a {
    &.disabled {
      pointer-events: none;
      cursor: not-allowed;
      color: #da9c15;
    }
    &.active {
      background-color: #da9c15;
      border-color: #ddd;
      color: #ffffff;
      box-shadow: 0px 5px 25px 0px rgba(0, 0, 0, 0.2);
      &:hover, &:focus {
        background-color: #da9c15;
        border-color: #ddd;
        color: #fff;
        box-shadow: 0px 5px 25px 0px rgba(0, 0, 0, 0.2);
      }
    }
  }

`;



// WEBPACK FOOTER //
// ./src/pagination/components.js